<template>
    <v-container class="mt-5">
        <v-row>
            <v-col md="12" cols="12">
                <h1>فكرة الموقع</h1>
            </v-col>
        </v-row>

        <v-row>
            <v-col md="12" cols="12">

               <p>تم تصميم هذا الموقع لمساعدة الأشخاص في اختيار طبخة اليوم, حيث يقوم الموقع باقتراح اسم طبخة عشوائيا مع رابط فيديو من اليوتيوب لكيفية التحضير.</p>
               
               <p>يمكن اختيار المكونات و سيقوم الموقع بعرض جميع الطبخات التي تطابق هذه المكونات.</p>
               <p>يمكن لأي مستخدم أن يضيف طبخة غير موجودة مسبقا بعد التسجيل في الموقع و ستضاف الطبخة مباشرة ضمن قائمة اقتراح الطبخات.</p>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'About',
    computed: {
      ...mapGetters(['loading', 'user'])
    },
}
</script>